export default `  mutation setPaymentMethodOnCart($input: SetPaymentMethodOnCartInput) {
  setPaymentMethodOnCart(input: $input) {
    cart {
      svea_iframe_link
      svea_iframe_snippet
    }
  }
}
`;
